module.exports = __webpack_public_path__ + "static/nexusguard-fbd8456dac097703945b00a038f7ec0e.jpeg";